export const locale = {
  'PROBLEM' : {
    'BREAKAGE' : 'Broken',
    'INACTIVITY' : 'Inactive',
    'DELAY' : 'Delay on stage',
    'STOPPAGE' : 'Stoppage',
  },
}
